<template>
  <a-layout class="approved-application-box">
    <a-card class="create-application" :bordered=false :loading="loading">
      <div slot="title" v-if="pageLayout.pageTitle">
        <a-icon style="cursor:pointer;" type="left-circle" @click="back" />
        <div>{{pageLayout.pageTitle}}</div>
      </div>
      <div slot="extra" style="cursor:pointer" class="extra" v-if="pageLayout.functions">
        <span v-for="(item,index) in pageLayout.functions" :key="index" style="margin-left:17px;">
          <span class="extra-trigger" @click="print" v-if="item.action==='print'">
            <a-icon style="cursor:pointer" slot="suffixIcon" :component="'SvgIcFile'" />打印
          </span>
        </span>
      </div>
      <div v-for="(layout,index) in pageLayout.contents" :key="index" v-if="loadedInfo && !loading">
        <common-form :ref="'commonForm'" :layout="layout" v-if="layout.type==='commonForm'" :params="layout.field && params[layout.field]?params[layout.field]:{}"></common-form>
        <multi-form :ref="'multiForm'" :layout="layout" v-if="layout.type==='multiForm'" :params="layout.field && params[layout.field]?params[layout.field]:[]"></multi-form>
        <summation :layout="layout" v-if="layout.type==='summation'" :params="params[layout.field]?params[layout.field]:{}" :all-params="params" @changed-fields="setSummationInfo" :from-detail="true"></summation>
        <upload v-if="layout.type==='upload'" :layout="layout" :params="params[layout.field]?params[layout.field]:[]" :can-edit="canEdit"></upload>
        <a-divider/>
      </div>
      <approval-flow :params="approvalFlowInfo" :init-text="'审批流数据加载中...'" v-if="loadedInfo && !loading"></approval-flow>
      <div style="text-align:center" v-else>
        <a-spin tip="数据加载中..."></a-spin>
      </div>
      <a-row class="footer">
        <a-col :xs="24" :sm="4"></a-col>
        <a-col :xs="24" :sm="20">
          <a-button @click="visibleComment = true" style="width:120px;" v-if="loadedInfo && !loading">评论</a-button>
        </a-col>
      </a-row>
    </a-card>
    <comment-and-copy :visible="visibleComment" @cancel="visibleComment = false" @reload="reload"></comment-and-copy>
  </a-layout>
</template>

<script>
import UUID from "uuidjs";

import SvgIcBackbtn from "../../assets/svg/ic-left-circle-o.svg";
import SvgIcFile from "../../assets/svg/ic-file-o.svg";
import CommonForm from "../../components/CommonForm.vue";
import MultiForm from "../../components/MultiForm.vue";
import Summation from "../../components/Summation.vue";
import ApprovalFlow from "../../components/ApprovalFlow.vue";
import FormModal from "../../components/FormModal.vue";
import Upload from "../../components/Upload.vue";

import { setTimeout } from "timers";
import LayoutConfig from "../../utils/LayoutConfig.js";
import { layoutConfig } from "../../utils/mockData.js";
import {
  backInfoFormModal,
  agreeInfoFormModal
} from "../../data/formModalConfigs.js";
import {
  getProPaymentLayout,
  getProPaymentDetail,
  getDetailApprovalFlow,
  printUrl
} from "../../services/CommonService.js";

export default {
  components: {
    SvgIcBackbtn,
    SvgIcFile,
    CommonForm,
    MultiForm,
    Summation,
    ApprovalFlow,
    FormModal,
    Upload
  },
  data() {
    return {
      canEdit: false,
      breadcrumb: [
        {
          label: "我已审批",
          path: ""
        }
      ],
      cardHeight: 0,
      params: {},
      loading: false,
      loadedInfo: false,
      pageLayout: layoutConfig,
      approvalFlowInfo: [],
      visibleComment: false
    };
  },

  created() {
    this.id = this.$route.query.id;
    Promise.all([this.getProPaymentDetail()]).then(() => {
      this.fetchLayout();
    });
    this.fetchApprovalFlow();
  },
  mounted() {},

  computed: {},

  methods: {
    fetchApprovalFlow() {
      getDetailApprovalFlow({ id: this.$route.query.id }).then(res => {
        if (res.status === "success") {
          res.data.forEach((item, index) => {
            this.$set(this.approvalFlowInfo, index, item);
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    setSummationInfo(e) {
      this.summationInfo = e;
    },
    fetchLayout() {
      this.loading = true;
      getProPaymentLayout({
        id: this.id,
        menu_type: 3,
        type: "detail",
        ding_msg_switch:
          window.location.href.indexOf("fromLocation=msg") !== -1 ? 1 : 0
      }).then(res => {
        if (res.status === "success") {
          this.pageLayout = res.data;
          this.loading = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getProPaymentDetail() {
      getProPaymentDetail(this.id, { menu_type: 3 }).then(res => {
        if (res.status === "success") {
          this.params = Object.assign({}, this.params, res.data);
          this.loadedInfo = true;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    back() {
      this.$router.replace({
        name: "approvedByMeList"
      });
    },
    print() {
      let url = `${window.location.origin}/api/fas/project-payment/${
        this.$route.query.id
      }/pdf`;
      url.replace(" ", "");
      location.href = url;
    },

    reload() {
      this.visibleComment = false;
      this.fetchApprovalFlow();
    }
  }
};
</script>

<style lang="less">
.approved-application-box {
  padding: 16px;
}
</style>
